export default class CompositeStorageManager {
    constructor(storageManagers) {
        this.storageManagers = storageManagers;
    }
    store() {
        this.storageManagers.forEach((storageManager) => storageManager.store());
    }
    restore() {
        this.storageManagers.forEach((storageManager) => storageManager.restore());
    }
}
